import script from "./IdentificationsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentificationsIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__